module.exports = __webpack_public_path__ + "img/scene-ys.538a07bf.png";